/**
 * Pertenencia de un usuario a un cliente (spec 2026-10-05).
 *
 * Fuente de hoy: customers/{cid}.Usuarios[] = {email, reference, isAdmin?}.
 * Desde 2026-10 también UsuariosUids (array plano de uid), que permite
 * consultar con array-contains: el array-contains sobre el OBJETO de
 * Usuarios fallaba cuando la entrada tenía isAdmin. Se miran las dos para
 * no depender de que la migración ya haya corrido.
 *
 * Módulo puro, para poder testearlo directo.
 */

const entries = (data) => (Array.isArray(data?.Usuarios) ? data.Usuarios : []);

export const memberEntry = (data, uid) =>
  entries(data).find((u) => u && u.reference && u.reference.id === uid);

export const isMember = (data, uid) => !!uid && (
  (Array.isArray(data?.UsuariosUids) && data.UsuariosUids.includes(uid))
  || !!memberEntry(data, uid)
);

export const diffLinks = (before = [], after = []) => {
  const b = new Set(before || []);
  const a = new Set(after || []);
  return { add: [...a].filter((x) => !b.has(x)), remove: [...b].filter((x) => !a.has(x)) };
};

export const linkedCustomerIds = (customers, uid) =>
  (customers || []).filter((c) => isMember(c?.data, uid)).map((c) => c.cid);
